import React from 'react';
import { useAppSelector } from '../../redux/hooks';
import CustomCard from '../../shared/customCard/CustomCard';
import './discoverSection.scss';

export type DisoverCardProps = {
  loading?: boolean;
  image: any;
  from: any;
  to: any;
  price?: any;
  journeyTime?: string;
  handleSet?: any
  showFrom?: string,
  showTo?: string,
  provider?: string
}

const DiscoverCard = ({ loading, image, from, to, price, journeyTime, handleSet }: DisoverCardProps) => {
  // let currency = useAppSelector((state) => state.common.currency.value);
  return (
    <CustomCard className="discover-card">
      <div
        onClick={handleSet}>
        <div>
          <div className="discover-card--image-container">
            <img src={image} alt={`${image}`} className="discover-card--image" />
          </div>
          <div className="discover-card--content">
            <div className="inner w-50">
              <p>From</p>
              <p className="bold-text">{from}</p>
              <p>To</p>
              <p className="bold-text">{to}</p>
            </div>
            <div className="virticle-devider"></div>
            <div className="inner">
              {
                price === false ? <p className="not-found-text">No Fares Today</p> :
                  <>
                    <p>Starting From</p>
                    <p className="price">{loading ? 'Loading' : price}</p>
                    <p>Journey Time</p>
                    <p className="time">{loading ? 'Loading' : journeyTime}</p>
                  </>
              }

            </div>
          </div>
        </div>
      </div>
    </CustomCard>
  );
}

export default DiscoverCard;
